"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.effects = void 0;

var bounce_1 = __importDefault(require("./bounce"));

var flash_1 = __importDefault(require("./flash"));

var pulse_1 = __importDefault(require("./pulse"));

var rubberBand_1 = __importDefault(require("./rubberBand"));

var shakeX_1 = __importDefault(require("./shakeX"));

var shakeY_1 = __importDefault(require("./shakeY"));

var headShake_1 = __importDefault(require("./headShake"));

var swing_1 = __importDefault(require("./swing"));

var tada_1 = __importDefault(require("./tada"));

var wobble_1 = __importDefault(require("./wobble"));

var jello_1 = __importDefault(require("./jello"));

var heartBeat_1 = __importDefault(require("./heartBeat"));

var backInDown_1 = __importDefault(require("./backInDown"));

var backInLeft_1 = __importDefault(require("./backInLeft"));

var backInRight_1 = __importDefault(require("./backInRight"));

var backInUp_1 = __importDefault(require("./backInUp"));

var backOutDown_1 = __importDefault(require("./backOutDown"));

var backOutLeft_1 = __importDefault(require("./backOutLeft"));

var backOutRight_1 = __importDefault(require("./backOutRight"));

var backOutUp_1 = __importDefault(require("./backOutUp"));

var bounceIn_1 = __importDefault(require("./bounceIn"));

var bounceInDown_1 = __importDefault(require("./bounceInDown"));

var bounceInLeft_1 = __importDefault(require("./bounceInLeft"));

var bounceInRight_1 = __importDefault(require("./bounceInRight"));

var bounceInUp_1 = __importDefault(require("./bounceInUp"));

var bounceOut_1 = __importDefault(require("./bounceOut"));

var bounceOutDown_1 = __importDefault(require("./bounceOutDown"));

var bounceOutLeft_1 = __importDefault(require("./bounceOutLeft"));

var bounceOutRight_1 = __importDefault(require("./bounceOutRight"));

var bounceOutUp_1 = __importDefault(require("./bounceOutUp"));

var fadeIn_1 = __importDefault(require("./fadeIn"));

var fadeInDown_1 = __importDefault(require("./fadeInDown"));

var fadeInDownBig_1 = __importDefault(require("./fadeInDownBig"));

var fadeInLeft_1 = __importDefault(require("./fadeInLeft"));

var fadeInLeftBig_1 = __importDefault(require("./fadeInLeftBig"));

var fadeInRight_1 = __importDefault(require("./fadeInRight"));

var fadeInRightBig_1 = __importDefault(require("./fadeInRightBig"));

var fadeInUp_1 = __importDefault(require("./fadeInUp"));

var fadeInUpBig_1 = __importDefault(require("./fadeInUpBig"));

var fadeInTopLeft_1 = __importDefault(require("./fadeInTopLeft"));

var fadeInTopRight_1 = __importDefault(require("./fadeInTopRight"));

var fadeInBottomLeft_1 = __importDefault(require("./fadeInBottomLeft"));

var fadeInBottomRight_1 = __importDefault(require("./fadeInBottomRight"));

var fadeOut_1 = __importDefault(require("./fadeOut"));

var fadeOutDown_1 = __importDefault(require("./fadeOutDown"));

var fadeOutDownBig_1 = __importDefault(require("./fadeOutDownBig"));

var fadeOutLeft_1 = __importDefault(require("./fadeOutLeft"));

var fadeOutLeftBig_1 = __importDefault(require("./fadeOutLeftBig"));

var fadeOutRight_1 = __importDefault(require("./fadeOutRight"));

var fadeOutRightBig_1 = __importDefault(require("./fadeOutRightBig"));

var fadeOutUp_1 = __importDefault(require("./fadeOutUp"));

var fadeOutUpBig_1 = __importDefault(require("./fadeOutUpBig"));

var fadeOutTopLeft_1 = __importDefault(require("./fadeOutTopLeft"));

var fadeOutTopRight_1 = __importDefault(require("./fadeOutTopRight"));

var fadeOutBottomLeft_1 = __importDefault(require("./fadeOutBottomLeft"));

var fadeOutBottomRight_1 = __importDefault(require("./fadeOutBottomRight"));

var flip_1 = __importDefault(require("./flip"));

var flipInX_1 = __importDefault(require("./flipInX"));

var flipInY_1 = __importDefault(require("./flipInY"));

var flipOutX_1 = __importDefault(require("./flipOutX"));

var flipOutY_1 = __importDefault(require("./flipOutY"));

var lightSpeedInRight_1 = __importDefault(require("./lightSpeedInRight"));

var lightSpeedInLeft_1 = __importDefault(require("./lightSpeedInLeft"));

var lightSpeedOutRight_1 = __importDefault(require("./lightSpeedOutRight"));

var lightSpeedOutLeft_1 = __importDefault(require("./lightSpeedOutLeft"));

var rotateIn_1 = __importDefault(require("./rotateIn"));

var rotateInDownLeft_1 = __importDefault(require("./rotateInDownLeft"));

var rotateInDownRight_1 = __importDefault(require("./rotateInDownRight"));

var rotateInUpLeft_1 = __importDefault(require("./rotateInUpLeft"));

var rotateInUpRight_1 = __importDefault(require("./rotateInUpRight"));

var rotateOut_1 = __importDefault(require("./rotateOut"));

var rotateOutDownLeft_1 = __importDefault(require("./rotateOutDownLeft"));

var rotateOutDownRight_1 = __importDefault(require("./rotateOutDownRight"));

var rotateOutUpLeft_1 = __importDefault(require("./rotateOutUpLeft"));

var rotateOutUpRight_1 = __importDefault(require("./rotateOutUpRight"));

var hinge_1 = __importDefault(require("./hinge"));

var jackInTheBox_1 = __importDefault(require("./jackInTheBox"));

var rollIn_1 = __importDefault(require("./rollIn"));

var rollOut_1 = __importDefault(require("./rollOut"));

var zoomIn_1 = __importDefault(require("./zoomIn"));

var zoomInDown_1 = __importDefault(require("./zoomInDown"));

var zoomInLeft_1 = __importDefault(require("./zoomInLeft"));

var zoomInRight_1 = __importDefault(require("./zoomInRight"));

var zoomInUp_1 = __importDefault(require("./zoomInUp"));

var zoomOut_1 = __importDefault(require("./zoomOut"));

var zoomOutDown_1 = __importDefault(require("./zoomOutDown"));

var zoomOutLeft_1 = __importDefault(require("./zoomOutLeft"));

var zoomOutRight_1 = __importDefault(require("./zoomOutRight"));

var zoomOutUp_1 = __importDefault(require("./zoomOutUp"));

var slideInDown_1 = __importDefault(require("./slideInDown"));

var slideInLeft_1 = __importDefault(require("./slideInLeft"));

var slideInRight_1 = __importDefault(require("./slideInRight"));

var slideInUp_1 = __importDefault(require("./slideInUp"));

var slideOutDown_1 = __importDefault(require("./slideOutDown"));

var slideOutLeft_1 = __importDefault(require("./slideOutLeft"));

var slideOutRight_1 = __importDefault(require("./slideOutRight"));

var slideOutUp_1 = __importDefault(require("./slideOutUp"));

exports.effects = {
  bounce: bounce_1.default,
  flash: flash_1.default,
  pulse: pulse_1.default,
  rubberBand: rubberBand_1.default,
  shakeX: shakeX_1.default,
  shakeY: shakeY_1.default,
  headShake: headShake_1.default,
  swing: swing_1.default,
  tada: tada_1.default,
  wobble: wobble_1.default,
  jello: jello_1.default,
  heartBeat: heartBeat_1.default,
  backInDown: backInDown_1.default,
  backInLeft: backInLeft_1.default,
  backInRight: backInRight_1.default,
  backInUp: backInUp_1.default,
  backOutDown: backOutDown_1.default,
  backOutLeft: backOutLeft_1.default,
  backOutRight: backOutRight_1.default,
  backOutUp: backOutUp_1.default,
  bounceIn: bounceIn_1.default,
  bounceInDown: bounceInDown_1.default,
  bounceInLeft: bounceInLeft_1.default,
  bounceInRight: bounceInRight_1.default,
  bounceInUp: bounceInUp_1.default,
  bounceOut: bounceOut_1.default,
  bounceOutDown: bounceOutDown_1.default,
  bounceOutLeft: bounceOutLeft_1.default,
  bounceOutRight: bounceOutRight_1.default,
  bounceOutUp: bounceOutUp_1.default,
  fadeIn: fadeIn_1.default,
  fadeInDown: fadeInDown_1.default,
  fadeInDownBig: fadeInDownBig_1.default,
  fadeInLeft: fadeInLeft_1.default,
  fadeInLeftBig: fadeInLeftBig_1.default,
  fadeInRight: fadeInRight_1.default,
  fadeInRightBig: fadeInRightBig_1.default,
  fadeInUp: fadeInUp_1.default,
  fadeInUpBig: fadeInUpBig_1.default,
  fadeInTopLeft: fadeInTopLeft_1.default,
  fadeInTopRight: fadeInTopRight_1.default,
  fadeInBottomLeft: fadeInBottomLeft_1.default,
  fadeInBottomRight: fadeInBottomRight_1.default,
  fadeOut: fadeOut_1.default,
  fadeOutDown: fadeOutDown_1.default,
  fadeOutDownBig: fadeOutDownBig_1.default,
  fadeOutLeft: fadeOutLeft_1.default,
  fadeOutLeftBig: fadeOutLeftBig_1.default,
  fadeOutRight: fadeOutRight_1.default,
  fadeOutRightBig: fadeOutRightBig_1.default,
  fadeOutUp: fadeOutUp_1.default,
  fadeOutUpBig: fadeOutUpBig_1.default,
  fadeOutTopLeft: fadeOutTopLeft_1.default,
  fadeOutTopRight: fadeOutTopRight_1.default,
  fadeOutBottomLeft: fadeOutBottomLeft_1.default,
  fadeOutBottomRight: fadeOutBottomRight_1.default,
  flip: flip_1.default,
  flipInX: flipInX_1.default,
  flipInY: flipInY_1.default,
  flipOutX: flipOutX_1.default,
  flipOutY: flipOutY_1.default,
  lightSpeedInRight: lightSpeedInRight_1.default,
  lightSpeedInLeft: lightSpeedInLeft_1.default,
  lightSpeedOutRight: lightSpeedOutRight_1.default,
  lightSpeedOutLeft: lightSpeedOutLeft_1.default,
  rotateIn: rotateIn_1.default,
  rotateInDownLeft: rotateInDownLeft_1.default,
  rotateInDownRight: rotateInDownRight_1.default,
  rotateInUpLeft: rotateInUpLeft_1.default,
  rotateInUpRight: rotateInUpRight_1.default,
  rotateOut: rotateOut_1.default,
  rotateOutDownLeft: rotateOutDownLeft_1.default,
  rotateOutDownRight: rotateOutDownRight_1.default,
  rotateOutUpLeft: rotateOutUpLeft_1.default,
  rotateOutUpRight: rotateOutUpRight_1.default,
  hinge: hinge_1.default,
  jackInTheBox: jackInTheBox_1.default,
  rollIn: rollIn_1.default,
  rollOut: rollOut_1.default,
  zoomIn: zoomIn_1.default,
  zoomInDown: zoomInDown_1.default,
  zoomInLeft: zoomInLeft_1.default,
  zoomInRight: zoomInRight_1.default,
  zoomInUp: zoomInUp_1.default,
  zoomOut: zoomOut_1.default,
  zoomOutDown: zoomOutDown_1.default,
  zoomOutLeft: zoomOutLeft_1.default,
  zoomOutRight: zoomOutRight_1.default,
  zoomOutUp: zoomOutUp_1.default,
  slideInDown: slideInDown_1.default,
  slideInLeft: slideInLeft_1.default,
  slideInRight: slideInRight_1.default,
  slideInUp: slideInUp_1.default,
  slideOutDown: slideOutDown_1.default,
  slideOutLeft: slideOutLeft_1.default,
  slideOutRight: slideOutRight_1.default,
  slideOutUp: slideOutUp_1.default
};